import { TableView } from "../view";

// <reference path="../view.ts" />
// <reference path="hsa-alloc.ts" />

export class HealthySoilsAssessmentViews extends TableView {

    constructor() {
        super(false, false, false, [new HealthySoilsAssessmentView(), new HealthySoilsAssessmentAllocView()], true);
        this._key = this._template = "grouphsa";
        this._name = "Healthy soils assessment";
    }
}

export class HealthySoilsAssessmentView extends TableView {

    constructor() {
        super(false, false, false, null, true);
        this._key = this._template = this._template = "hsa";
        this._name = "List";
    }

}

export class HealthySoilsAssessmentAllocView extends TableView {

    constructor() {
        super(false, true, false, null, true);
        this._key = this._template = this._template = "hsa-alloc";
        this._name = "Allocations";
    }

}

